import { AnimatedSprite } from "pixi.js/lib";
import { Character, Coordinate } from "../pixiApplication";
import { ratfink } from "../spritesheets/ratfink";
import { loadSound, playSound } from "../audio";

let count = 0;

export class Ratfink implements Character {
  sprite: AnimatedSprite;
  position: Coordinate;
  caught = false;
  squeakTask: NodeJS.Timeout;
  id: string;

  async initSprites() {
    this.sprite = await ratfink();
    this.sprite.animationSpeed = 0.1;

    this.id = `ratfink-${count++}`;
  }

  tick() {
    if (this.caught) {
      return;
    }
    const delta = 5 - Math.floor(Math.random() * 11);
    this.position.x += delta;
    if (delta === 0) {
      this.sprite.stop();
    } else if (delta > 0) {
      this.sprite.play();
      this.sprite.scale.x = Math.abs(this.sprite.scale.x);
    } else {
      this.sprite.play();
      this.sprite.scale.x = -1 * Math.abs(this.sprite.scale.x);
    }

    if (Math.random() < 0.1) {
      clearTimeout(this.squeakTask);
      this.squeakTask = setTimeout(
        () => {
          const squeak = loadSound("squeak");
          squeak.volume = 0.25;
          playSound(squeak, "GAME");
        },
        Math.random() * Math.abs(delta) * 200,
      );
    }
  }

  catch() {
    this.caught = true;
    clearTimeout(this.squeakTask);
    this.sprite.visible = false;
    const squeak = loadSound("squeak");
    squeak.volume = 0.25;
    playSound(squeak, "GAME");
  }

  release(position: Coordinate) {
    this.position = position;
    this.sprite.visible = true;
    this.caught = false;
  }
}
